import { render, staticRenderFns } from "./expireDetail.vue?vue&type=template&id=2942ee01&scoped=true"
import script from "./expireDetail.vue?vue&type=script&lang=js"
export * from "./expireDetail.vue?vue&type=script&lang=js"
import style0 from "./expireDetail.vue?vue&type=style&index=0&id=2942ee01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2942ee01",
  null
  
)

export default component.exports